module.exports = __webpack_public_path__ + "static/media/banner_header_cancer_mama.0b1793c9.svg";